/*
 * @Author: Merlin
 * @Date: 2024-01-17 14:36:14
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-17 14:36:33
 * @Description: 
 */
import step01 from '../img/rules/rule01.png';
import step02 from '../img/rules/rule02.png';
import MobileStep01 from '../img/rules/mobile-rule01.png';
import MobileStep02 from '../img/rules/mobile-rule02.png';

export const aCrashRule = [{
    content1: 'crash.ruleDesc01',
    constent2: '',
    img: step01,
    imgMobile: MobileStep01,
},{
    content1: 'crash.ruleDesc01',
    constent2: '',
    img: step02,
    imgMobile: MobileStep02,
},];

